import { useResponsive } from '@sg/garnish';

import { useIsFoldableDevice } from '../../../../hooks/useIsFoldableDevice';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns the number of product columns in the menu grid.
 *
 * A foldable's open display, such as the iPhone Duo's, sits in the SM
 * breakpoint but is wide enough for a third column.
 */
export const useMenuGridColumns = () => {
  const { currentBreakpoint, match } = useResponsive();
  const isFoldableDevice = useIsFoldableDevice();

  const isOpenFoldableDisplay = currentBreakpoint.isSM && isFoldableDevice;

  if (isOpenFoldableDisplay) {
    return 3;
  }

  return match([1, 2, 3, 4]);
};
